<template>
  <div
    class="main d-flex flex-column align-center justify-center"
    data-tourid="routineQr-printable-portraitQr"
  >
    <img :src="defaultLogo" alt="logo" />
    <span class="title mb-6 blue-grey--text text--darken-3 body1">{{
      title
    }}</span>
    <QRCode :value="qrUrl" size="370" level="L" v-if="qrUrl" />
  </div>
</template>

<script>
import QRCode from 'qrcode.vue'
import defaultLogo from '@/assets/images/logo-bw.svg'
export default {
  name: 'QRPortrait',

  components: {
    QRCode,
  },
  props: {
    qrUrl: {
      type: String,
      required: true,
    },
    definition: {
      type: Object,
    },
  },
  data() {
    return {
      defaultLogo,
    }
  },
  computed: {
    title() {
      return this.definition?.name
    },
  },
  methods: {},
}
</script>
<style scoped>
.title {
  margin-top: 88px;
}
</style>
